import { USER_STATUS_TITLE } from '../constants';
import { USER_STATUS } from '../enums';

export const getUserStatus = (status: USER_STATUS) => {
	return USER_STATUS_TITLE[status] || status;
};
